module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-layout childs-details"
  }, [_c('form', [(_vm.participant && _vm.lookups['gender_id'] && _vm.lookups['tshirt_size_id'] && _vm.lookups['swimming_ability_id']) ? _c('div', {
    staticClass: "form"
  }, [_c('transition-group', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.errors.errors.length > 0) ? _c('div', {
    key: "error",
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner alerts-banner"
  }, [_c('div', {
    staticClass: "full-width dark-red"
  }, [_c('div', {
    staticClass: "price-subtotal"
  }, [_c('span', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.locale.form.text_error))])])])])]) : _vm._e(), _vm._v(" "), (_vm.$route.query.notify) ? _c('div', {
    key: "info",
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [_c('a', {
    staticClass: "acc-alerts urgent"
  }, [_c('i', {
    staticClass: "fa fa-child"
  }), _vm._v(" "), _c('span', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.form.text_notify_alert)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })])])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, [_vm._l((_vm.formData), function(fields, step) {
    return (_vm.required_fields[fields[0].name].indexOf('required') > -1 || _vm.required_fields[fields[0].name].indexOf('validschool') > -1 || _vm.show_non_required) ? _c('div', {
      key: 'step-' + (step + 1),
      staticClass: "steps",
      attrs: {
        "id": 'step-' + (step + 1)
      }
    }, [_c('form-field', {
      key: "fields.top",
      attrs: {
        "data": fields,
        "step": step,
        "lookups": _vm.lookups,
        "dateofbirth": _vm.dateofbirth,
        "dob": _vm.dob,
        "participant": _vm.participant,
        "required_fields": _vm.required_fields
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_non_required && _vm.formData.length > 0),
      expression: "!show_non_required && formData.length > 0"
    }],
    key: "form-expand",
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "form-layout"
  }, [_c('div', {
    staticClass: "row more-details"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.locale.form.text_expanded_form_description)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "expand cta-button blue",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.form.button_expanded_form_text)
    },
    on: {
      "click": function($event) {
        _vm.show_non_required = true
      }
    }
  })])])]), _vm._v(" "), _vm._l((_vm.formDataBottom), function(fields, step) {
    return (_vm.required_fields[fields[0].name].indexOf('required') > -1 || _vm.show_non_required) ? _c('div', {
      key: 'step-' + (step + 1),
      staticClass: "steps",
      attrs: {
        "id": 'step-' + (step + 1)
      }
    }, [_c('form-field', {
      key: "fields.top",
      attrs: {
        "data": fields,
        "step": step,
        "participant": _vm.participant,
        "formData": _vm.formData,
        "required_fields": _vm.required_fields
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.formData.length > 0) ? _c('div', {
    key: "form-continue",
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "form-layout"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "continue cta-button red",
    on: {
      "click": function($event) {
        _vm.progress(_vm.participant.id)
      }
    }
  }, [_vm._v(_vm._s((_vm.$route.params.hasOwnProperty('id') ? (_vm.$route.query.hasOwnProperty('notify') ? 'Update and confirm child details' : 'Update child details') : 'Confirm child details')))])])])]) : _vm._e()], 2)], 1)])], 1) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-layout"
  }, [_c('span', [_c('div', {
    attrs: {
      "id": "important_information",
      "data-field": "important_information"
    }
  }, [_c('label', [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Important Information")]), _vm._v(" "), _c('br'), _vm._v("Please note this information will be shared with the Camp Manager of your child/ren’s camp\n                        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-5x dark"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15a9c5c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/Participants/ParticipantComplete.vue
// module id = 157
// module chunks = 0